import { Component, Inject, OnInit, PLATFORM_ID, OnDestroy, ElementRef, Renderer2, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MktDynamicOfferService } from 'src/app/core/services/mkt-dynamic-offer.service';
import { MktModalService } from 'src/app/core/services/mkt-modal.service';
import { Title } from '@angular/platform-browser';
import { isPlatformBrowser, Location } from '@angular/common';
import { MktTaggingTransformationService } from 'src/app/core/services/mkt-tagging-transformation.service';
import { MktSiteCatalystService } from 'src/app/core/services/mkt-site-catalyst.service';
import { AdaFriendlyNamePipe } from 'src/app/common/pipes/ada-friendly-name.pipe';
import { Subscription } from 'rxjs';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { OfferUtilService } from 'src/app/common/services';
import { FootnoteService } from 'src/app/common/services/footnote.service';
import { ScrollFocusService } from 'src/app/common/services/scroll-focus.service';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

const products = [];
const ADDITIONAL_INFO_URL = 'additional-information';

@Component({
  selector: 'app-price-detail-section',
  templateUrl: './price-detail-section.component.html',
  styleUrls: ['./price-detail-section.component.scss'],
  standalone: true,
  imports: [MktCommonModule]
})
export class PriceDetailSectionComponent implements OnInit, OnDestroy, AfterViewInit {

  pricingDetailContentDescriptionType: string = "description";
  pricingDetailContent: any = null;
  isAdditionalInfo: boolean;
  additionalInfoContent: any = null;
  cardApplyNowBtnLink: string;
  cardNameParam: string;
  pid: number;
  isModalOpen :boolean = false;
  private pdpSiteCatalyst = {};
  private dynamicOfferSub: Subscription = new Subscription();
  @Output() pricingInfoClicked = new EventEmitter<any>();
  @Output() additionalInfoClicked = new EventEmitter<any>();
  @Input() cardDetails: any = {};
  productType: string;

  constructor(
    private route: ActivatedRoute,
    private mktDynamicOfferService: MktDynamicOfferService,
    private readonly scrollFocusService: ScrollFocusService,
    private titleService: Title,
    private modalService: MktModalService,
    private _mktContentStorageService: MktContentStorageService,
    private location: Location,
    private router: Router,
    private mktSiteCatalystService: MktSiteCatalystService,
    private _mktTagging: MktTaggingTransformationService,
    private adaFriendlyNamePipe: AdaFriendlyNamePipe,
    private elementRef: ElementRef,
    private renderer2: Renderer2,
    private offerUtilService: OfferUtilService,
    private footnoteService: FootnoteService,
    @Inject(PLATFORM_ID) public platformId: string,
  ) {
    this.cardNameParam = this.route.snapshot.paramMap.get('cardName');
    this.isAdditionalInfo = this.route.snapshot.data?.isAdditionalInfo;
  }

  ngOnInit() {
    this.getPriceDetailSectionContents();

    if (this.isAdditionalInfo) {
      if (this.modalService.modalArray.length === 0) {
        this.openAdditionalInfoPage();
      }
    }
  }

  ngAfterViewInit() {
    this.handleCitWorkflow();
  }

  private handleCitWorkflow() {
    this.dynamicOfferSub.add(this.mktDynamicOfferService.getPriceDetailObj().subscribe(priceDetail => {
      if (priceDetail?.length === 0 || (!!priceDetail && (priceDetail.balconGoToRateIdentifier === undefined || priceDetail.balconGoToRateIdentifier === "0"))) {
        this.handleJulyCitWorkflow(priceDetail)
        return;
      }
      if (this.pricingDetailContent["descriptionFlexPlanFeeN"] === undefined || this.pricingDetailContent["descriptionFlexPlanFeeY"] === undefined) return;
      this.pricingDetailContent["description"] = this.pricingDetailContent[`descriptionFlexPlanFee${priceDetail["flexPlanFeeFlag"] ? 'Y' : 'N'}`]; // flexPlanFeeFlag = true/false
      let instance = setTimeout(() => { this.offerUtilService.injectDynamicText(this.elementRef, this.renderer2, priceDetail, this.pid, this.productType); clearTimeout(instance); }, 1000);
    }));
  }

  private handleJulyCitWorkflow(priceDetail) {
    let citTerm = priceDetail["flexPlanFeeFlag"];
    this.pricingDetailContent["description"] = this.pricingDetailContent[`description${citTerm ? 'FlexPlanFeeJuly' : ''}`]; // flexPlanFeeFlag = true/false
    let instance = setTimeout(() => { this.offerUtilService.injectDynamicText(this.elementRef, this.renderer2, priceDetail, this.pid, this.productType); clearTimeout(instance); }, 1000);
  }

  ngOnDestroy() {
    this.dynamicOfferSub.unsubscribe();
  }

  private async getPriceDetailSectionContents() {
    //  Try to get card pricing details
    const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', this.cardNameParam, undefined);
    if (!mainPdpContentObject) {
      return;
    }
    this.pricingDetailContent = JSON.parse(mainPdpContentObject['pricingDetailSection']);
    const pdpText = JSON.parse(mainPdpContentObject?.TEXT || '{}');
    this.pid = pdpText?.pid;
    this.productType = pdpText?.productType;
    const mainPdpContentObjectText= JSON.parse(mainPdpContentObject.TEXT);
    this.pdpSiteCatalyst = JSON.parse(mainPdpContentObject['siteCatalyst']);

    const addInfoContentObject = this._mktContentStorageService.get('Additional_Info_Pages', 'copy', this.cardNameParam, undefined);
    if (addInfoContentObject) {
      // return;
      const additionalInfoContent = JSON.parse(addInfoContentObject['TEXT'] || '{}');
      this.additionalInfoContent = {
        content: '',
        siteCatalyst: {},
        showCancelButton: true,
        cancelButtonText: 'Close',
        primaryButtonText: '',
        url: '',
        useDefaults: false,
        ...additionalInfoContent
      };
    }
    if (!this.pricingDetailContent || !this.pricingDetailContent.pricingDetailActive) { return; }

    this.generateDynamicLinks(this.pricingDetailContent,mainPdpContentObjectText);
  }

  private generateDynamicLinks(pricingContent: any,mainPdpContentObjectText) {
    this.dynamicOfferSub.add(this.mktDynamicOfferService.getApplyNowContent().subscribe((content) => {
      pricingContent.additionalLinks.forEach(linkItem => {
        if (linkItem.linkType == "pricingInfo") {
          linkItem.link = content.termsUrl;
          if(content?.termsUrl){
            mainPdpContentObjectText['pricingInfoLink']=content.termsUrl;
            setTimeout(()=>this.footnoteService.addFootNote(this.elementRef,this.renderer2,
              {...mainPdpContentObjectText, pricingInfo: mainPdpContentObjectText.pricingAndInfoText},
               this.navigateToAdditionalInfoPage, this, 'pdp'),2000);
              }
            }
          });
          if(this.cardDetails?.isCRSPage){
            setTimeout(()=>this.footnoteService.addFootNote(this.elementRef, this.renderer2,
              {...mainPdpContentObjectText, pricingInfo: mainPdpContentObjectText.pricingAndInfoText},
              this.scroll, this, 'pdp', 'scroll'),0);
          }
    }));
  }
  private scroll = (event, elementId, page)=> this.scrollFocusService.scrollFocus(event,elementId, page);

  public navigateToAdditionalInfoPage(event: MouseEvent) {
    if(!this.additionalInfoContent){
      console.error('Additional Info Content is not available');
      return;
    }
    // Set browser url
    const currentPageURL = this.router.url.split('?');
    let urlPath = currentPageURL[0].split('/');
    urlPath = urlPath.filter(part => part != ADDITIONAL_INFO_URL);
    urlPath.push(ADDITIONAL_INFO_URL);
    if(currentPageURL[1]){
      this.location.replaceState(urlPath.join('/'), currentPageURL[1] );
    }else{
      this.location.replaceState(urlPath.join('/'));
    }
    this.openAdditionalInfoPage(event);
  }

  public openAdditionalInfoPage(event = {}) {
    // Store current document title for use after modal is closed
    const pdpTitle = this.titleService.getTitle();

    // // TODO: Remove temp data
    // this.additionalInfoContent = content;

    // Set new document title for the modal
    const modalTitle = this.adaFriendlyNamePipe.ariaLabel(this.additionalInfoContent.title || 'Additional Information');
    this.titleService.setTitle(modalTitle);

    // Set Generic Template Component and data
    this.additionalInfoContent.genericTemplateContent = this.additionalInfoContent;

    // Open modal
    if (!this.isModalOpen) {
      this.isModalOpen=true;
      const modalInstance = this.modalService.openModal(event, this.additionalInfoContent, false);

      // Setup Subscriptions
      if (isPlatformBrowser(this.platformId)) {
        const handleOnClose = () => {
          // Set document title back to pdp title after modal closed
          this.titleService.setTitle(pdpTitle);

          this.closeAdditionalInfoPage();

          modalCloseSub.unsubscribe();
          modalContinueSub.unsubscribe();
        };

        // Subscribe to modal close emitter
        const modalCloseSub = !!modalInstance && modalInstance.onClose.subscribe(handleOnClose.bind(this));

        // Subscribe to modal continue emitter
        const modalContinueSub = !!modalInstance && modalInstance.onContinue.subscribe(handleOnClose.bind(this));
      }
    }

    this.setAdditionalInfoBothTagging();

    return false;
  }

  private closeAdditionalInfoPage() {
    console.log('onclose -model');
    this.isModalOpen=false;
    this.mktSiteCatalystService.callSC('naAnalyticsPageView', this.pdpSiteCatalyst['pageLoadTag']);
    // this.location.go(this.router.url.replace("/additional-information", ""));

    const arr = this.router.url.split('?');
    arr[0] = arr[0].split('/').filter(part => part != ADDITIONAL_INFO_URL).join('/');
    this.location.replaceState(arr.join('?'));
    // this.router.navigate([ ...currentPageURL ], { replaceUrl: true });
  }

  private setAdditionalInfoBothTagging() {
    this.mktSiteCatalystService.callSC('naAnalyticsPageView', this.additionalInfoContent?.siteCatalyst?.pageLoadTag);
    // this.setTaggingDl();
    // this.initTaggingTransformationCc();
  }

  private setTaggingDl() {
    const taggingIcmsContent = this._mktContentStorageService.get(
      'Additional_Info_Pages',
      'copy',
      'Additional_info_tagging_content',
      undefined
    );
    this.mktDynamicOfferService.setTaggingStaticIcms(taggingIcmsContent);
  }

  private initTaggingTransformationCc() {
    const productName = this.mktDynamicOfferService.productType[this.pid];
    products.push({
      product_name: 'c:' + this.pid,
    });

    this._mktTagging.tagMktCompareCards('cardAdditionalInfo', {
      pid: this.pid, app_hierarchy: `public|marketing|${productName}|additional information`, products: products
    });

  }

  pricingInfo(value){
    this.pricingInfoClicked.emit(value);
  }

  additionalInfo(event){
    this.additionalInfoClicked.emit(event);
  }
}

